//报表类型
export enum TABLE_TYPE {
    PERIOD = 1, // 商家周期汇总表
    DAILY = 2, // 商家每日明细表
    RESULT = 3, // 运营结果汇总表
    DISTRIBUTE = 4, // 分配商家明细表
    LIVEDAILY = 5, // 直播商家交易明细表
    LIVERESULT = 6, // 直播商家交易汇总表
}

export const tableTypeMap = {
    [TABLE_TYPE.PERIOD]: '商家周期汇总表',
    [TABLE_TYPE.DAILY]: '商家每日明细表',
    [TABLE_TYPE.RESULT]: '运营结果汇总表',
    [TABLE_TYPE.DISTRIBUTE]: '分配商家明细表',
    [TABLE_TYPE.LIVEDAILY]: '直播商家交易明细表',
    [TABLE_TYPE.LIVERESULT]: '直播商家交易汇总表',
};

// export enum CONTRACT_TYPE {
//     OFFICIAL_APY = '1', // 官方补贴代运营合同
//     OFFICIAL_SALE = '8', // 官方售卖代运营合同
//     PAY = '3', // 按效付费代运营合同
// }

// export const contractTypeMap = {
//     [CONTRACT_TYPE.OFFICIAL_APY]: '官方补贴代运营合同',
//     [CONTRACT_TYPE.OFFICIAL_SALE]: '官方售卖代运营合同',
//     [CONTRACT_TYPE.PAY]: '按效付费代运营合同',
// };

// export enum COOPERATE_TYPE {
//     PAY = '2', // 按效付费模式
//     PAY_NEW = '3', // 官方代运营补贴新店模式
//     PAY_OLD = '4', // 官方代运营补贴老店模式
//     SALE_NEW = '5', // 官方代运营售卖新店模式
//     SALE_OLD = '6', // 官方代运营售卖老店模式
// }

// export const cooperateTypeMap = {
//     [COOPERATE_TYPE.PAY]: '按效付费模式',
//     [COOPERATE_TYPE.PAY_NEW]: '官方代运营补贴新店模式',
//     [COOPERATE_TYPE.PAY_OLD]: '官方代运营补贴老店模式',
//     [COOPERATE_TYPE.SALE_NEW]: '官方代运营售卖新店模式',
//     [COOPERATE_TYPE.SALE_OLD]: '官方代运营售卖老店模式',
// };

export enum CUSTOMER_SOURCE {
    OFFICIAL = '1', // 官方代运营
    SERVICE = '2', // 服务市场业务
    SELF = '3', // 品牌分账
}

export const customerTypeMap = {
    [CUSTOMER_SOURCE.OFFICIAL]: '官方代运营',
    [CUSTOMER_SOURCE.SERVICE]: '服务市场业务',
    [CUSTOMER_SOURCE.SELF]: '品牌分账',
};

export interface IAnyliseFormProps {
    /** 报表类型 */
    type: number;
    /** label标题 */
    title: string;
    /** 按钮内容 */
    buttonTitle: string;
    /** 更新表格函数 */
    updateTableData: () => void;
    /** 日期选择的起始日期 */
    startDate: string;
    /** 日期选项框类型是否为范围，默认flase */
    dateRange?: boolean;
}

export interface PageReq {
    /** 页数 */
    pageNo: number;
    /** 每页大小 */
    pageSize: number;
}

export interface SubmitReq {
    /** 报表类型 */
    type: number;
    /** 客户来源 */
    customerSource: string;
    /** 开始日期 */
    startDate?: string;
    /** 结束日期 */
    endDate?: string;
    /** 查询日期 */
    queryDate?: string;
    /** 合作模式 */
    coopMode: string | number;
}

export interface GetDownloadDetail {
    /** 提交时间 */
    ctime: string;
    /** 查询的开始日期 */
    startDate: string;
    /** 查询的结束日期 */
    endDate: string;
    /** 查询日期 */
    queryDate: string;
    /** 报表类型 */
    type: number;
    /** 状态 */
    status: 0 | 1;
    /** 下载链接 */
    s3Link: string;
}

//处理foreach使用的接口
export type IMap = {
    [key in string | number]: any;
};

export interface ICooperateItem {
    value: string | number;
    label: string;
}
export type ICooperateList = ICooperateItem[];

export interface ILiveCustomerSources {
    value: number;
    label: string;
    modes: ICooperateList;
}

export interface IPermissionRes {
    permission: boolean;
    customerSources: ILiveCustomerSources[];
}

export interface ILiveAnyliseFormProps {
    /** select 相关筛选项 */
    customerSources: ILiveCustomerSources[];
    /** 报表类型 */
    type: number;
    /** label标题 */
    title: string;
    /** 更新表格函数 */
    updateTableData: () => void;
}
